export default __webpack_public_path__ + "assets/06_Sketch.png";